module.exports = __webpack_public_path__ + "img/6.2-gallery.fe9cbcb8.jpg";